"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonStringifyRecursive_1 = __importDefault(require("../../shared/jsonStringifyRecursive"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getStringFromUnknown = (value) => {
    try {
        return (0, valueIsRecord_1.default)(value) ? (0, jsonStringifyRecursive_1.default)(value) : `${value}`;
    }
    catch (_a) {
        return `${value}`;
    }
};
const callableSendAlert = ({ entryVars: { title = '', subtitle = '', imageSrc }, processor, }) => {
    const newTitle = getStringFromUnknown(title);
    const newSubtitle = getStringFromUnknown(subtitle);
    if ((0, valueIsString_1.default)(imageSrc)) {
        const onOk = () => {
            processor.root.openAlert({
                isOpened: false,
                imageSrc: undefined,
                title: '',
                description: '',
                onOk: undefined,
            });
        };
        processor.root.openAlert({
            isOpened: true,
            title: newTitle,
            description: newSubtitle,
            imageSrc,
            onOk,
        });
    }
    else {
        processor.root.alert(newTitle, newSubtitle, [
            {
                text: 'Ok',
                onPress: () => undefined,
            },
        ]);
    }
};
exports.default = callableSendAlert;
